
export * from '../../frontend-taglib-clay/__liferay__/exports/@clayui$navigation-bar.js';

import __default__ from '../../frontend-taglib-clay/__liferay__/exports/@clayui$navigation-bar.js';
export default __default__;
